<template>
    <div class="p-1">
        <DKP v-if="form_name === 'ДКП БУ Кредит'" :form_name="form_name" :deal="deal" :condition="'used'" :in_credit="true" />
        <DKP v-if="form_name === 'ДКП БУ Наличка'" :form_name="form_name" :deal="deal" :condition="'used'" :in_credit="false" />
        <DKP v-if="form_name === 'ДКП Новый Кредит'" :form_name="form_name" :deal="deal" :condition="'new'" :in_credit="true" />
        <DKP v-if="form_name === 'ДКП Новый Наличка'" :form_name="form_name" :deal="deal" :condition="'new'" :in_credit="false" />

        <APP_TS v-if="form_name === 'АПП ТС БУ Кредит'" :form_name="form_name" :deal="deal" :condition="'used'" :in_credit="true" />
        <APP_TS v-if="form_name === 'АПП ТС БУ Наличка'" :form_name="form_name" :deal="deal" :condition="'used'" :in_credit="false" />
        <APP_TS v-if="form_name === 'АПП ТС Новый Кредит'" :form_name="form_name" :deal="deal" :condition="'new'" :in_credit="true" />
        <APP_TS v-if="form_name === 'АПП ТС Новый Наличка'" :form_name="form_name" :deal="deal" :condition="'new'" :in_credit="false" />

        <AgentskiiDogovor v-if="form_name === 'Агентский договор'" :form_name="form_name" />
        <DogovorKomissii v-if="form_name === 'Договор комиссии ФЛ ЮЛ'" :form_name="form_name" :counteragent_type="'person'" :deal="deal" />
        <DogovorKomissii v-if="form_name === 'Договор комиссии ЮЛ ЮЛ'" :form_name="form_name" :counteragent_type="'company'" :deal="deal" />

        <SoglashenieNaDolg v-if="form_name === 'Соглашение на долг'" :form_name="form_name" :deal="deal" />
        <SoglashenieNaSkidku v-if="form_name === 'Соглашение на скидку'" :form_name="form_name" :deal="deal" />
        <SoglasheniePoSkidkeIDopam v-if="form_name === 'Соглашение по скидке и допам'" :form_name="form_name" :deal="deal" />
        <SoglasheniePoSkidkeIDopam v-if="form_name === 'Заявление на скидку'" :form_name="form_name" :deal="deal" />
    </div>
</template>

<script>
import DKP from "./forms/DKP";
import APP_TS from "./forms/APP_TS";
import AgentskiiDogovor from "./forms/AgentskiiDogovor";
import DogovorKomissii from "./forms/DogovorKomissii";
import SoglashenieNaDolg from "./forms/SoglashenieNaDolg";
import SoglashenieNaSkidku from "./forms/SoglashenieNaSkidku";
import SoglasheniePoSkidkeIDopam from "./forms/SoglasheniePoSkidkeIDopam";
export default {
    name: "DocumentForm",
    components: {
        SoglasheniePoSkidkeIDopam,
        SoglashenieNaSkidku, SoglashenieNaDolg, DogovorKomissii, AgentskiiDogovor, APP_TS, DKP},
    props: {
        deal: {
            type: Object,
            required: true,
        },
        form_name: {
            type: String,
            required: true,
        }
    },
    data: () => ({

    }),
}
</script>

<style scoped>

</style>
